import {Observable} from 'rxjs/Observable';
import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';
import {copyPrizeCompleteAction, copyPrizeErrorAction, Types} from './actions';

const copyPrizeEpic = (action$, store) => action$.ofType(Types.SUBMIT_COPY_PRIZE)
  .mergeMap(({title, lang}) => {
    const state = store.getState();
    const sourcePrize = state.resources.resources[state.copyPrize.copyPrizeId];
    const resourceIds = [{type: ResourceApi.Types.Prize, id: sourcePrize.id}];

    const prizeCopy$ = ResourceApi.copy(ResourceApi.Types.Prize, {title, lang}, resourceIds);

    return prizeCopy$
      .mergeMap(({response}) => Observable.of(
        copyPrizeCompleteAction(response.object.resourceId.id),
        ResourceActions.createdResourceAction(response.object, null, [], [], [])
      ))
      .catch(error => Observable.of(
        error.xhr
          ? copyPrizeErrorAction(error.response)
          : {type: 'ERROR', error}
      ));
  });

export default [
  copyPrizeEpic
];



// WEBPACK FOOTER //
// ./public/pages/PrizeCopy/epics.js